import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NextStepsService } from '@features/next-steps/services/next-steps.service';
import { PopoverController } from '@ionic/angular';
import { NextStep } from '@shared/models/next-step';
import moment from 'moment';
import { skipWhile } from 'rxjs';
import { take } from 'rxjs/internal/operators/take';

@Component({
  selector: 'app-add-next-step',
  templateUrl: './add-next-step.component.html',
  styleUrl: './add-next-step.component.scss',
  standalone: false,
})
export class AddNextStepComponent implements OnInit {
  @Input() leadId?: number;
  @Input() opportunityId?: number;
  @Input() groupId?: string;

  nextStepForm: FormGroup;
  today: string = moment().format('YYYY-MM-DD');
  loadingState$ = this.nextStepsService.getNextStepsLoading();

  constructor(
    private nextStepsService: NextStepsService,
    private popoverController: PopoverController,
  ) {}

  ngOnInit() {
    this.nextStepForm = new FormGroup({
      description: new FormControl('', [Validators.minLength(3), Validators.required]),
      due_date: new FormControl('', [Validators.required]),
    });
  }

  closePopover() {
    this.popoverController.dismiss();
  }

  createNextStep() {
    this.nextStepForm.markAllAsTouched();
    if (this.nextStepForm.invalid) return;

    const newNextStep: Partial<NextStep> = {
      attributes: {
        description: this.nextStepForm.value.description.trim(),
        due_date: this.nextStepForm.value.due_date,
        lead_id: this.leadId,
        opportunity_id: this.opportunityId,
        group_id: this.groupId,
      },
    } as Partial<NextStep>;

    this.nextStepsService.createNextStep(newNextStep);

    this.loadingState$
      .pipe(
        skipWhile((state) => state === 'loading'),
        take(1),
      )
      .subscribe(() => {
        this.closePopover();
      });
  }
}
